import Vue from "vue";
import App from "./App.vue";
import "./style.scss";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";
import auth from "./middlewares/auth";

/** Axios */
import Axios from "axios";
Axios.defaults.baseURL = "/api";
Axios.defaults.headers.common["Accepts"] = "application/json";
Axios.defaults.headers.common["Content-Type"] = "application/json";
Axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
Axios.interceptors.request.use(function(config) {
  config.headers["Device-Id"] = localStorage.getItem("device_id") || "";
  config.headers["Device-Code"] = localStorage.getItem("device_code") || "";

  return config;
});
Axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data.code === "DEVICE_NOT_AUTHORIZED"
    ) {
      router.replace({ name: "deviceNotAuthorized" });
    }

    // Sessão vencida ou encerrada (logout, senha trocada), usuário bloqueado ou cookie de CSRF vencido (419):
    // volta para o login. As rotas /auth/* tratam a resposta por conta própria.
    const sessaoEncerrada =
      error.response &&
      ((error.response.status === 401 &&
        ["UNAUTHENTICATED", "USER_BLOCKED"].includes(error.response.data.code)) ||
        error.response.status === 419);
    if (sessaoEncerrada && !(error.config.url || "").startsWith("/auth/")) {
      store.commit("clearUser");
      store.commit(
        "setMessage",
        error.response.status === 419
          ? "Sua sessão expirou. Faça login novamente."
          : error.response.data.message
      );
      if (router.currentRoute.name !== "login") {
        router.replace({
          name: "login",
          query: { from: router.currentRoute.fullPath }
        });
      }
    }

    return Promise.reject(error);
  }
);
Vue.prototype.$http = Axios;
// Resto do login por token (antes da sessão por cookie).
localStorage.removeItem("token");
/** /Axios */

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
  store.commit("setLoading", { loading: true });
  if (to.name !== "login")
    store.dispatch("checkSession").then(() => {
      store.commit("setLoading", { loading: false });
      if (store.getters.isLoggedin) next();
      else next({ name: "login", query: { from: to.path } });
    });
  else next();
});

// V-mask
import "@/plugins/v-mask";

//Vuetify Money
import "@/plugins/vuetify-money";

// Moment
import "@/plugins/moment";

// Vee-Validate
import "@/plugins/vee-validate";

// Lodash
import _ from "lodash";
Vue.prototype._ = _;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
